var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 276.187,
    height: 285.916,
    viewBox: "0 0 276.187 285.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-46.106 -47.346)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.606 47.846)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.171,
    height: 8.524,
    transform: "translate(11.252 173.685)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.171,
    height: 8.523,
    transform: "translate(0 184.433)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.171,
    height: 8.523,
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.171,
    height: 8.523,
    transform: "translate(255.016)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.171,
    height: 8.524,
    transform: "translate(243.764 10.748)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.171,
    height: 8.523,
    transform: "translate(192.105 110.462)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.171,
    height: 8.523,
    transform: "translate(180.853 121.21)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.171,
    height: 8.523,
    transform: "translate(169.646 110.462)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.171,
    height: 8.523,
    transform: "translate(255.016 184.433)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.171,
    height: 8.524,
    transform: "translate(83.639 25.346)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.652 33.316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.246,169.6l3.972-6.4-1.961-1.215a1.792,1.792,0,0,1-.832-1.685,10.256,10.256,0,0,0,.036-1.126,1.79,1.79,0,0,1,.935-1.626l2.033-1.09-3.563-6.642-2.032,1.09a1.79,1.79,0,0,1-1.872-.12,10.645,10.645,0,0,0-.958-.594,1.791,1.791,0,0,1-.944-1.625l.073-2.306-7.531-.234-.069,2.314a1.792,1.792,0,0,1-1.051,1.559c-.167.079-.331.163-.5.25s-.324.179-.482.275a1.787,1.787,0,0,1-1.871.013l-1.975-1.223-3.972,6.4,1.965,1.219a1.793,1.793,0,0,1,.83,1.687,10.546,10.546,0,0,0-.037,1.122,1.79,1.79,0,0,1-.934,1.624l-2.033,1.09L393.038,169l2.034-1.09a1.789,1.789,0,0,1,1.87.119,10.326,10.326,0,0,0,.955.59,1.792,1.792,0,0,1,.946,1.624l-.072,2.311,7.532.234.072-2.312a1.789,1.789,0,0,1,1.048-1.554q.251-.118.5-.252c.163-.088.325-.179.482-.275a1.8,1.8,0,0,1,1.88-.013Zm-6.376-4.755a6.172,6.172,0,1,1,2.526-8.355A6.168,6.168,0,0,1,405.87,164.848Z",
    transform: "translate(-172.432 -112.585)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.551,277.142l3.972-6.4-1.961-1.215a1.79,1.79,0,0,1-.831-1.685,10.625,10.625,0,0,0,.036-1.127,1.79,1.79,0,0,1,.934-1.625L94.733,264l-3.562-6.642-2.033,1.09a1.79,1.79,0,0,1-1.872-.121,10.312,10.312,0,0,0-.958-.593,1.793,1.793,0,0,1-.944-1.625l.074-2.305-7.532-.234-.07,2.314a1.792,1.792,0,0,1-1.05,1.559q-.25.118-.5.25c-.163.088-.325.179-.482.275a1.787,1.787,0,0,1-1.871.014l-1.975-1.224-3.972,6.4,1.965,1.219a1.791,1.791,0,0,1,.83,1.687,10.364,10.364,0,0,0-.036,1.122,1.79,1.79,0,0,1-.935,1.624L67.78,269.9l3.562,6.643,2.033-1.09a1.79,1.79,0,0,1,1.87.119,10.463,10.463,0,0,0,.955.59,1.791,1.791,0,0,1,.946,1.625l-.071,2.311,7.531.234.072-2.312a1.788,1.788,0,0,1,1.047-1.554c.167-.079.334-.163.5-.252s.325-.179.482-.275a1.794,1.794,0,0,1,1.88-.013Zm-6.377-4.755a6.172,6.172,0,1,1,2.527-8.355A6.168,6.168,0,0,1,84.174,272.387Z",
    transform: "translate(-67.78 -147.568)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.831,103.394l-2.638-4.572-1.4.808a1.255,1.255,0,0,1-1.316-.045,7.371,7.371,0,0,0-.683-.4,1.253,1.253,0,0,1-.694-1.115V96.46H194.82v1.616a1.253,1.253,0,0,1-.694,1.115,7.37,7.37,0,0,0-.683.4,1.256,1.256,0,0,1-1.316.045l-1.4-.808-2.638,4.572,1.405.81a1.256,1.256,0,0,1,.615,1.165q-.01.193-.01.389t.01.389a1.251,1.251,0,0,1-.611,1.159l-1.409.814,2.638,4.572,1.4-.809a1.255,1.255,0,0,1,1.316.046,7.253,7.253,0,0,0,.681.394,1.255,1.255,0,0,1,.693,1.115v1.617H200.1v-1.617a1.255,1.255,0,0,1,.693-1.115,7.158,7.158,0,0,0,.68-.394,1.256,1.256,0,0,1,1.316-.046l1.4.809,2.638-4.572-1.4-.81a1.254,1.254,0,0,1-.613-1.161q.01-.194.01-.391t-.01-.389a1.257,1.257,0,0,1,.615-1.165Zm-5.047,2.363a4.324,4.324,0,1,1-4.322-4.326A4.321,4.321,0,0,1,201.784,105.757Z",
    transform: "translate(-106.918 -96.46)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.634 304.823)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.566,
    cy: 14.219,
    rx: 100.566,
    ry: 14.219,
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.194 76.928)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.492,184.822,133.3,168.34l-33.085,8.409-4.373-17.2,26.44-60.257L135.4,95.954l12.75,50.169,10.587-2.691,4.4,17.325-10.587,2.691,4.189,16.483Zm-22.668-30.23,16.362-4.158-5.412-21.3Z",
    transform: "translate(-95.846 -92.062)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.777,127.922A44.228,44.228,0,0,1,264.295,143a37.441,37.441,0,0,1-6.828,11.917,30.913,30.913,0,0,1-10.24,7.82,29.635,29.635,0,0,1-12.849,2.793,30.027,30.027,0,0,1-12.909-2.793,30.693,30.693,0,0,1-10.3-7.82A36.5,36.5,0,0,1,204.4,143a48.194,48.194,0,0,1,0-30.165,36.491,36.491,0,0,1,6.766-11.917,31.45,31.45,0,0,1,10.3-7.883,29.491,29.491,0,0,1,12.909-2.855,29.107,29.107,0,0,1,12.849,2.855,31.687,31.687,0,0,1,10.24,7.883,37.426,37.426,0,0,1,6.828,11.917A44.224,44.224,0,0,1,266.777,127.922Zm-19.986,0q0-8.687-3.476-14.089t-8.938-5.4q-5.711,0-9.123,5.4t-3.414,14.089q0,8.69,3.414,14.027t9.123,5.337q5.462,0,8.938-5.337T246.791,127.922Z",
    transform: "translate(-130.372 -90.185)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.907,182.212l2.72-16.788-33.7-5.459,2.838-17.523,48.245-44.749,13.357,2.164-8.278,51.1,10.784,1.747-2.859,17.645L358.233,168.6l-2.72,16.788Zm-8.758-36.756,16.665,2.7,3.514-21.689Z",
    transform: "translate(-163.864 -92.628)",
    fill: "#0c4767"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99.069 150.455)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.071 77.374)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.96,
    height: 1.963,
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.96,
    height: 1.963,
    transform: "translate(0 2.557)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.96,
    height: 1.963,
    transform: "translate(0 5.113)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.96,
    height: 1.963,
    transform: "translate(0 7.67)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.96,
    height: 1.963,
    transform: "translate(0 10.226)",
    fill: "#0c4767"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.85 138.6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.552,
    height: 1.963,
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.552,
    height: 1.963,
    transform: "translate(0 2.557)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.552,
    height: 1.963,
    transform: "translate(0 5.113)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.552,
    height: 1.963,
    transform: "translate(0 7.67)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.552,
    height: 1.963,
    transform: "translate(0 10.226)",
    fill: "#0c4767"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.893)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 20.362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.027,270.132c.022-.265-9.971-3.612-9.971-3.612l.59-34.332,13.25-2.843Z",
    transform: "translate(-174.056 -229.344)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.027,270.132c.022-.265-9.971-3.612-9.971-3.612l.59-34.332,13.25-2.843Z",
    transform: "translate(-174.056 -229.344)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.495 34.997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.489,290.664c.07-.256,10.6.039,10.6.039l11.26-32.438-11.462-7.229Z",
    transform: "translate(-324.489 -251.036)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.489,290.664c.07-.256,10.6.039,10.6.039l11.26-32.438-11.462-7.229Z",
    transform: "translate(-324.489 -251.036)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185.983,272.956s3.7-55.525,6.954-73.792c0,0,67.075,5.073,103.285,18.913,0,0-18.669,64.856-19.634,68.074C276.588,286.152,229.355,276.847,185.983,272.956Z",
    transform: "translate(-177.936 -199.164)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.314 7.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.192,210.155q-1.635,10.028-3.336,20.046L264.4,250.225l-.187-.283,22.474,5.339L297.912,258l11.213,2.774-11.272-2.523-11.259-2.576L264.1,250.422l-.227-.053.041-.23,3.579-20Q269.3,220.138,271.192,210.155Z",
    transform: "translate(-260.588 -210.155)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.809,215.171a1.312,1.312,0,0,1-1.178,1.3,1.31,1.31,0,1,1,0-2.608A1.313,1.313,0,0,1,269.809,215.171Zm0,0a1.052,1.052,0,0,0-1.178-1.05,1.06,1.06,0,0,0,0,2.1,1.052,1.052,0,0,0,1.178-1.052Z",
    transform: "translate(-261.671 -211.36)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.063,227.416a1.312,1.312,0,0,1-1.177,1.3,1.311,1.311,0,1,1,0-2.609A1.313,1.313,0,0,1,268.063,227.416Zm0,0a1.051,1.051,0,0,0-1.177-1.051,1.06,1.06,0,0,0,0,2.1,1.053,1.053,0,0,0,1.177-1.053Z",
    transform: "translate(-261.103 -215.344)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.913,240.355a1.311,1.311,0,0,1-1.177,1.3,1.31,1.31,0,1,1,0-2.608A1.312,1.312,0,0,1,265.913,240.355Zm0,0a1.051,1.051,0,0,0-1.177-1.05,1.06,1.06,0,0,0,0,2.1,1.072,1.072,0,0,0,.808-.244A1.085,1.085,0,0,0,265.913,240.355Z",
    transform: "translate(-260.404 -219.553)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.763,253.294a1.312,1.312,0,0,1-1.177,1.3,1.31,1.31,0,1,1,0-2.608A1.312,1.312,0,0,1,263.763,253.294Zm0,0a1.051,1.051,0,0,0-1.177-1.051,1.06,1.06,0,0,0,0,2.1,1.053,1.053,0,0,0,1.177-1.052Z",
    transform: "translate(-259.704 -223.762)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.089,273.929a1.312,1.312,0,0,1-1.178,1.3,1.31,1.31,0,1,1,0-2.608A1.313,1.313,0,0,1,271.089,273.929Zm0,0a1.052,1.052,0,0,0-1.178-1.05,1.06,1.06,0,0,0,0,2.1,1.053,1.053,0,0,0,1.178-1.052Z",
    transform: "translate(-262.088 -230.475)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.3,276.908a1.311,1.311,0,0,1-1.178,1.3,1.31,1.31,0,1,1,0-2.608A1.312,1.312,0,0,1,283.3,276.908Zm0,0a1.051,1.051,0,0,0-1.178-1.05,1.06,1.06,0,0,0,0,2.1,1.072,1.072,0,0,0,.808-.244A1.085,1.085,0,0,0,283.3,276.908Z",
    transform: "translate(-266.061 -231.444)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.516,279.888a1.312,1.312,0,0,1-1.178,1.3,1.31,1.31,0,1,1,0-2.609A1.314,1.314,0,0,1,295.516,279.888Zm0,0a1.052,1.052,0,0,0-1.178-1.051,1.06,1.06,0,0,0,0,2.1,1.053,1.053,0,0,0,1.178-1.052Z",
    transform: "translate(-270.034 -232.414)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.729,282.867a1.312,1.312,0,0,1-1.178,1.3,1.31,1.31,0,1,1,0-2.608A1.313,1.313,0,0,1,307.729,282.867Zm0,0a1.051,1.051,0,0,0-1.178-1.05,1.06,1.06,0,0,0,0,2.1,1.053,1.053,0,0,0,1.178-1.052Z",
    transform: "translate(-274.007 -233.383)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.94,285.932a1.312,1.312,0,0,1-1.274,1.21,1.31,1.31,0,1,1,.2-2.6A1.312,1.312,0,0,1,319.94,285.932Zm0,0a1.051,1.051,0,0,0-1.093-1.138,1.06,1.06,0,0,0-.162,2.1,1.052,1.052,0,0,0,1.255-.958Z",
    transform: "translate(-277.981 -234.348)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.613,266.233a1.312,1.312,0,0,1-1.177,1.3,1.31,1.31,0,1,1,0-2.608A1.312,1.312,0,0,1,261.613,266.233Zm0,0a1.051,1.051,0,0,0-1.177-1.051,1.06,1.06,0,0,0,0,2.1,1.053,1.053,0,0,0,1.177-1.052Z",
    transform: "translate(-259.005 -227.972)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.415 19.077)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.047,
    cy: 19.047,
    r: 19.047,
    transform: "translate(0 25.471) rotate(-41.961)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.276,
    cy: 15.276,
    r: 15.276,
    transform: "translate(7.205 35.778) rotate(-69.267)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.531 16.565)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.618,
    height: 3.618,
    transform: "translate(5.872 4.15) rotate(9.202)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.618,
    height: 3.618,
    transform: "translate(2.88 0) rotate(9.202)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.618,
    height: 3.618,
    transform: "translate(17.164 2.314) rotate(9.202)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.618,
    height: 3.618,
    transform: "translate(0.579 14.204) rotate(9.202)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.618,
    height: 3.618,
    transform: "translate(14.863 16.518) rotate(9.202)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.618,
    height: 3.618,
    transform: "translate(4.728 11.211) rotate(9.202)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.618,
    height: 3.618,
    transform: "translate(8.871 8.259) rotate(9.202)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.618,
    height: 3.618,
    transform: "translate(13.014 5.307) rotate(9.202)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.618,
    height: 3.618,
    transform: "translate(11.87 12.368) rotate(9.203)",
    fill: "#fd9926"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.207 8.076)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.047,
    cy: 19.047,
    r: 19.047,
    transform: "translate(0 29.465) rotate(-50.667)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.047,
    cy: 19.047,
    r: 19.047,
    transform: "translate(0 29.465) rotate(-50.667)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.614,274.361c-.088.375-.188.737-.3,1.1l-37.127-7.919c.088-.663.206-1.325.363-1.994a19.049,19.049,0,1,1,37.064,8.813Z",
    transform: "translate(-263.276 -243.148)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 15.276,
    cy: 15.276,
    r: 15.276,
    transform: "translate(6.821 18.599) rotate(-22.676)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.964 17.628)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.618,
    height: 18.007,
    transform: "translate(4.164 0) rotate(13.369)",
    fill: "#fd9926"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.445 6.179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.495,273.243l-39-9.268a20.042,20.042,0,0,1,39,9.268Z",
    transform: "translate(-270.497 -248.568)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.495,273.243l-39-9.268a20.042,20.042,0,0,1,39,9.268Z",
    transform: "translate(-270.497 -248.568)",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M250.071,293.035a7.054,7.054,0,0,1,1.762-4.288,5.161,5.161,0,0,1,2.071-1.393,5.823,5.823,0,0,1,2.5-.277A4.647,4.647,0,0,1,260.315,290a7.8,7.8,0,0,1,.4,4.62,12.223,12.223,0,0,0-1.343-4.141,3.965,3.965,0,0,0-3.113-2.065,4.728,4.728,0,0,0-3.7,1.083A10,10,0,0,0,250.071,293.035Z",
    transform: "translate(-205.2 -246.831)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.264 1.605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.716,226.369c.159-2.036.387-4.06.58-6.09.217-2.027.439-4.053.686-6.075s.5-4.045.756-6.065.546-4.037.818-6.057l.072-.539.547.034q6.593.415,13.16,1.082,3.284.337,6.559.76c2.18.313,4.363.6,6.53,1l-13.168-.815-13.154-.851.619-.5c-.3,2.015-.576,4.033-.893,6.046s-.618,4.027-.955,6.037-.671,4.02-1.025,6.028C194.47,222.361,194.128,224.37,193.716,226.369Z",
    transform: "translate(-193.716 -201.543)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.411,254.49a16.638,16.638,0,0,1,3.048-6.808c.372-.51.795-.982,1.2-1.468.44-.454.9-.894,1.351-1.341.493-.4.99-.8,1.5-1.183.538-.341,1.069-.7,1.616-1.023.576-.277,1.148-.562,1.729-.824l1.81-.626,1.873-.387c.629-.092,1.268-.111,1.9-.159a18.355,18.355,0,0,1,7.333,1.405,26.1,26.1,0,0,0-7.273-.482,17.1,17.1,0,0,0-6.8,2.109,19.836,19.836,0,0,0-5.518,4.553A22.47,22.47,0,0,0,198.411,254.49Z",
    transform: "translate(-195.243 -214.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.287,263.2a16.626,16.626,0,0,1,3.958-6.321c.439-.455.923-.864,1.393-1.288.5-.389,1.013-.762,1.523-1.142.543-.329,1.091-.654,1.646-.965.58-.263,1.154-.542,1.741-.791.609-.194,1.214-.4,1.826-.578l1.879-.37,1.909-.124c.635,0,1.27.065,1.9.1a18.361,18.361,0,0,1,7.069,2.4A26.1,26.1,0,0,0,294,252.647a17.1,17.1,0,0,0-7.022,1.15,19.844,19.844,0,0,0-6.094,3.748A22.457,22.457,0,0,0,276.287,263.2Z",
    transform: "translate(-220.577 -217.834)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.192 48.252)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.295 15.903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.359,338.107c-4.879,0-15.56-1.1-22.434-9.935-8.794-11.306-5.616-33-5.476-33.92l3.818.58c-.032.208-3.066,20.976,4.707,30.969,7.6,9.77,21.382,8.367,21.52,8.351l.435,3.837A24.153,24.153,0,0,1,175.359,338.107Z",
    transform: "translate(-146.777 -294.252)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.359,338.107c-4.879,0-15.56-1.1-22.434-9.935-8.794-11.306-5.616-33-5.476-33.92l3.818.58c-.032.208-3.066,20.976,4.707,30.969,7.6,9.77,21.382,8.367,21.52,8.351l.435,3.837A24.153,24.153,0,0,1,175.359,338.107Z",
    transform: "translate(-146.777 -294.252)",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.391,289.791a13.312,13.312,0,0,1-2.131-.175c-6.441-1.043-9.292-4.9-10.55-7.946a20.2,20.2,0,0,1-.866-10.988L143.011,272a12.6,12.6,0,0,0,.347,6.509c.463,1.123,1.362,2.47,4.224,2.934,1.308.212,2.72.1,4.2-2.133a15.429,15.429,0,0,0,2.069-5.553l8.168,1.323a23.911,23.911,0,0,1-3.341,8.8C156.122,287.745,152.523,289.791,148.391,289.791Z",
    transform: "translate(-134.482 -270.681)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.675 43.689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.147,362.556c-.014-.176-6.92-1.279-6.92-1.279l-3.352-22.539,8.364-3.3Z",
    transform: "translate(-185.876 -335.435)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.147,362.556c-.014-.176-6.92-1.279-6.92-1.279l-3.352-22.539,8.364-3.3Z",
    transform: "translate(-185.876 -335.435)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(113.222 43.779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.3,362.641c.018-.176,6.947-1.126,6.947-1.126l3.849-22.459-8.289-3.487Z",
    transform: "translate(-302.296 -335.569)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.3,362.641c.018-.176,6.947-1.126,6.947-1.126l3.849-22.459-8.289-3.487Z",
    transform: "translate(-302.296 -335.569)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.841,327.536s55.855-2.388,74.722.756c0,0-5.54,54.046-5.84,55.095,0,0-55.561-.15-64.246,0C201.476,383.387,196.769,347.449,196.841,327.536Z",
    transform: "translate(-154.768 -288.894)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.037 53.014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.987,349.695s30.491-1.2,40.791.381c0,0-3.025,27.253-3.188,27.782,0,0-30.331-.076-35.073,0C224.517,377.858,222.434,359.205,221.987,349.695Z",
    transform: "translate(-221.985 -349.257)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.154,378.024c-.7,0-1.252.009-1.639.013,0,0-2.081-18.656-2.531-28.166,0,0,.694-.027,1.9-.068Z",
    transform: "translate(-221.984 -349.435)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.711 1.944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.727,358.068a3.243,3.243,0,1,0,2.116,4.068A3.243,3.243,0,0,0,237.727,358.068Zm1.741,3.949a2.847,2.847,0,1,1-1.858-3.57A2.847,2.847,0,0,1,239.468,362.017Zm-1.741-3.949a3.243,3.243,0,1,0,2.116,4.068A3.243,3.243,0,0,0,237.727,358.068Zm1.741,3.949a2.847,2.847,0,1,1-1.858-3.57A2.847,2.847,0,0,1,239.468,362.017Zm-1.741-3.949a3.243,3.243,0,1,0,2.116,4.068A3.243,3.243,0,0,0,237.727,358.068Zm1.741,3.949a2.847,2.847,0,1,1-1.858-3.57A2.847,2.847,0,0,1,239.468,362.017Zm-.66-7.375a6.836,6.836,0,1,0,4.462,8.573A6.838,6.838,0,0,0,238.808,354.642Zm1.518,7.645a3.746,3.746,0,1,1-2.446-4.7A3.751,3.751,0,0,1,240.326,362.287Zm-.482-.15a3.242,3.242,0,1,0-4.065,2.118A3.243,3.243,0,0,0,239.844,362.136Zm-.376-.119a2.847,2.847,0,1,1-1.858-3.57A2.847,2.847,0,0,1,239.468,362.017Zm-1.741-3.949a3.243,3.243,0,1,0,2.116,4.068A3.243,3.243,0,0,0,237.727,358.068Zm1.741,3.949a2.847,2.847,0,1,1-1.858-3.57A2.847,2.847,0,0,1,239.468,362.017Zm-1.741-3.949a3.243,3.243,0,1,0,2.116,4.068A3.243,3.243,0,0,0,237.727,358.068Zm1.741,3.949a2.847,2.847,0,1,1-1.858-3.57A2.847,2.847,0,0,1,239.468,362.017Z",
    transform: "translate(-228.275 -352.85)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.577,373.924l-2.507-.79-.421,1.818,2.23.7Z",
    transform: "translate(-229.815 -358.969)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.962,369.7l-1.214-2.331-1.583.988,1.08,2.073Z",
    transform: "translate(-227.706 -357.094)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.215,362.231l.79-2.507-1.818-.421-.7,2.23Z",
    transform: "translate(-227.484 -354.47)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.178,355.616l2.331-1.214-.988-1.583-2.073,1.08Z",
    transform: "translate(-229.099 -352.36)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.713,353.87l2.507.79.421-1.818-2.23-.7Z",
    transform: "translate(-231.788 -352.139)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.39,357.832l1.214,2.331,1.583-.988-1.08-2.073Z",
    transform: "translate(-233.96 -353.753)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.27,365.367l-.79,2.507,1.818.421.7-2.23Z",
    transform: "translate(-234.315 -356.442)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.047,372.044l-2.331,1.214.988,1.583,2.073-1.08Z",
    transform: "translate(-232.439 -358.614)",
    fill: "#fd9926"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.263 12.887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.041,372.675a2.184,2.184,0,1,0,.637,3.021A2.184,2.184,0,0,0,255.041,372.675Zm.415,2.875a1.917,1.917,0,1,1-.56-2.652A1.916,1.916,0,0,1,255.456,375.551Zm-.415-2.875a2.184,2.184,0,1,0,.637,3.021A2.184,2.184,0,0,0,255.041,372.675Zm.415,2.875a1.917,1.917,0,1,1-.56-2.652A1.916,1.916,0,0,1,255.456,375.551Zm-.415-2.875a2.184,2.184,0,1,0,.637,3.021A2.184,2.184,0,0,0,255.041,372.675Zm.415,2.875a1.917,1.917,0,1,1-.56-2.652A1.916,1.916,0,0,1,255.456,375.551Zm.905-4.9a4.6,4.6,0,1,0,1.344,6.366A4.6,4.6,0,0,0,256.362,370.649Zm-.4,5.232a2.522,2.522,0,1,1-.737-3.49A2.525,2.525,0,0,1,255.964,375.881Zm-.285-.185a2.183,2.183,0,1,0-3.019.639A2.184,2.184,0,0,0,255.678,375.7Zm-.222-.146a1.917,1.917,0,1,1-.56-2.652A1.916,1.916,0,0,1,255.456,375.551Zm-.415-2.875a2.184,2.184,0,1,0,.637,3.021A2.184,2.184,0,0,0,255.041,372.675Zm.415,2.875a1.917,1.917,0,1,1-.56-2.652A1.916,1.916,0,0,1,255.456,375.551Zm-.415-2.875a2.184,2.184,0,1,0,.637,3.021A2.184,2.184,0,0,0,255.041,372.675Zm.415,2.875a1.917,1.917,0,1,1-.56-2.652A1.916,1.916,0,0,1,255.456,375.551Z",
    transform: "translate(-248.116 -368.86)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.6,382.453l-1.483-.966-.6,1.1,1.319.859Z",
    transform: "translate(-248.527 -372.629)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.142,378.619l-.366-1.731-1.205.355.325,1.54Z",
    transform: "translate(-247.57 -371.133)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.251,373.382l.966-1.483-1.1-.6-.859,1.319Z",
    transform: "translate(-247.793 -369.314)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.117,369.929l1.731-.366-.355-1.205-1.54.325Z",
    transform: "translate(-249.322 -368.358)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.263,370.039l1.483.965.6-1.1-1.319-.859Z",
    transform: "translate(-251.049 -368.58)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.964,373.9l.366,1.731,1.205-.355-.325-1.54Z",
    transform: "translate(-252.253 -370.109)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.666,379.05l-.965,1.483,1.1.6.859-1.319Z",
    transform: "translate(-251.842 -371.836)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.832,382.751l-1.731.366.355,1.205L258,384Z",
    transform: "translate(-250.346 -373.04)",
    fill: "#dbdbdb"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.642 46.575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.594,381.342l2.146.4,6.139-41.579-2.446-.449Z",
    transform: "translate(-286.789 -339.713)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.721,374.753l3.188-27.782,21.458-7.258s-5.84,42.078-5.84,41.629Z",
    transform: "translate(-277.721 -339.713)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.721,374.753l3.188-27.782,21.458-7.258s-5.84,42.078-5.84,41.629Z",
    transform: "translate(-277.721 -339.713)",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.239,344.677c-.35-2.3-.538-4.622-.682-6.944-.065-1.161-.1-2.324-.121-3.488s-.043-2.327-.009-3.491l.009-.306.3-.015c4.263-.229,8.523-.509,12.787-.7,4.264-.21,8.529-.4,12.8-.535-4.253.385-8.51.713-12.767,1.022-4.255.333-8.517.571-12.775.862l.307-.322-.018,3.475.04,3.476q.008,1.739.061,3.479Z",
    transform: "translate(-155.603 -289.719)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.882,348.315q1.995-.947,4.046-1.76c1.362-.555,2.737-1.079,4.127-1.561s2.79-.941,4.211-1.337a39.445,39.445,0,0,1,4.313-1.007l.36-.059-.064.343c-.337,1.8-.689,3.595-1.106,5.381.156-1.827.376-3.644.611-5.459l.3.285c-1.418.337-2.824.733-4.226,1.147s-2.8.86-4.19,1.314Z",
    transform: "translate(-184.06 -294.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.35 38.755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.4,328.122l.361,6.949.309,6.951.536,13.9.419,13.908.168,6.955.115,6.957-.362-6.949-.309-6.951-.535-13.9-.418-13.908-.168-6.955Z",
    transform: "translate(-209.831 -328.122)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.208,333.822a1.312,1.312,0,0,1-.9,1.511,1.31,1.31,0,1,1-.515-2.557A1.312,1.312,0,0,1,210.208,333.822Zm0,0a1.051,1.051,0,0,0-1.362-.8,1.06,1.06,0,0,0,.416,2.061,1.053,1.053,0,0,0,.947-1.264Z",
    transform: "translate(-207.626 -329.634)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.917,346.171a1.312,1.312,0,0,1-.9,1.511,1.31,1.31,0,1,1-.515-2.557A1.312,1.312,0,0,1,210.917,346.171Zm0,0a1.051,1.051,0,0,0-1.362-.8,1.06,1.06,0,0,0,.416,2.061,1.052,1.052,0,0,0,.947-1.264Z",
    transform: "translate(-207.857 -333.651)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.367,359.28a1.311,1.311,0,0,1-.9,1.511,1.31,1.31,0,1,1-.515-2.557A1.313,1.313,0,0,1,211.367,359.28Zm0,0a1.052,1.052,0,0,0-1.362-.8,1.06,1.06,0,0,0,.416,2.061,1.052,1.052,0,0,0,.947-1.264Z",
    transform: "translate(-208.003 -337.915)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.817,372.388a1.312,1.312,0,0,1-.9,1.511,1.311,1.311,0,1,1-.515-2.558A1.313,1.313,0,0,1,211.817,372.388Zm0,0a1.051,1.051,0,0,0-1.362-.8,1.06,1.06,0,0,0,.416,2.061,1.053,1.053,0,0,0,.947-1.264Z",
    transform: "translate(-208.15 -342.179)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.267,385.5a1.312,1.312,0,0,1-.9,1.511,1.31,1.31,0,1,1-.516-2.557A1.313,1.313,0,0,1,212.267,385.5Zm0,0a1.052,1.052,0,0,0-1.362-.8,1.06,1.06,0,0,0,.416,2.061,1.053,1.053,0,0,0,.947-1.264Z",
    transform: "translate(-208.296 -346.444)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.717,398.6a1.311,1.311,0,0,1-.9,1.511,1.31,1.31,0,1,1-.516-2.557A1.314,1.314,0,0,1,212.717,398.6Zm0,0a1.085,1.085,0,0,0-.522-.719,1.073,1.073,0,0,0-.84-.078,1.06,1.06,0,0,0,.416,2.061,1.053,1.053,0,0,0,.947-1.264Z",
    transform: "translate(-208.443 -350.708)",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 131.78)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.047,
    height: 3.861,
    transform: "translate(31.935 26.23) rotate(-16.86)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.047,
    height: 3.861,
    transform: "translate(31.935 26.23) rotate(-16.86)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.861,
    height: 5.735,
    transform: "translate(44.729 21.137) rotate(-17.644)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.615,429.823l-8.161-35.339-24.633,5.84,12.129,34.441Z",
    transform: "translate(-123.821 -394.484)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.958,428.026l-5.466,1.8-8.161-35.339,7.862,1.872Z",
    transform: "translate(-160.331 -394.484)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.958,428.026l-5.466,1.8-8.161-35.339,7.862,1.872Z",
    transform: "translate(-160.331 -394.484)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 4.193,
    cy: 4.193,
    r: 4.193,
    transform: "translate(59.928 14.3)",
    fill: "#fd9926"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.514 131.766)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.861,
    height: 33.047,
    transform: "matrix(0.292, -0.956, 0.956, 0.292, 3.629, 20.256)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.861,
    height: 33.047,
    transform: "matrix(0.292, -0.956, 0.956, 0.292, 3.629, 20.256)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.735,
    height: 3.861,
    transform: "matrix(0.305, -0.952, 0.952, 0.305, 18.151, 25.378)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.357,429.786l8.236-35.322,24.62,5.892-12.2,34.415Z",
    transform: "translate(-322.896 -394.464)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.262,427.978l5.462,1.809,8.236-35.322-7.866,1.855Z",
    transform: "translate(-320.262 -394.464)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.262,427.978l5.462,1.809,8.236-35.322-7.866,1.855Z",
    transform: "translate(-320.262 -394.464)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M275.764,419.72a4.193,4.193,0,1,0,4.2-4.184A4.193,4.193,0,0,0,275.764,419.72Z",
    transform: "translate(-275.764 -401.319)",
    fill: "#fd9926"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.496 95.737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.38,351.9c.1-.093,10.257-9.515,22.207-6.293,12.221,3.3,22.309,21.7,22.41,21.889l3.4-1.836c-.441-.817-10.964-20.054-24.8-23.78-14.072-3.8-25.4,6.77-25.872,7.222Z",
    transform: "translate(-318.72 -341.063)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.38,351.9c.1-.093,10.257-9.515,22.207-6.293,12.221,3.3,22.309,21.7,22.41,21.889l3.4-1.836c-.441-.817-10.964-20.054-24.8-23.78-14.072-3.8-25.4,6.77-25.872,7.222Z",
    transform: "translate(-318.72 -341.063)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.833,396.669l7.317-3.863a15.447,15.447,0,0,1-1.693-5.68c-.163-2.675.9-3.616,2.07-4.234,2.564-1.354,4.093-.817,5.138-.2a12.6,12.6,0,0,1,4.2,4.987l7.318-3.863a20.2,20.2,0,0,0-7.31-8.249c-2.841-1.675-7.438-3.036-13.208.01-4.5,2.374-6.793,6.655-6.465,12.053A23.918,23.918,0,0,0,380.833,396.669Z",
    transform: "translate(-338.059 -351.701)",
    fill: "#fd9926"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.496 81.973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.949,332.375c1.586-1.1,3.21-2.128,4.839-3.151s3.278-2.013,4.931-3,3.321-1.938,5.01-2.861l2.533-1.382c.857-.44,1.7-.9,2.569-1.322-.79.554-1.6,1.07-2.4,1.606l-2.438,1.545c-1.625,1.029-3.278,2.013-4.931,2.995s-3.322,1.938-5.01,2.861S326.676,331.518,324.949,332.375Z",
    transform: "translate(-320.746 -320.662)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.72,361.423c2.272,1.295,4.425,2.755,6.548,4.256,2.112,1.518,4.194,3.077,6.156,4.805-2.272-1.293-4.425-2.753-6.547-4.256C322.765,364.709,320.683,363.15,318.72,361.423Z",
    transform: "translate(-318.72 -333.922)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.249,358.545c1.753.532,3.479,1.134,5.2,1.746s3.429,1.259,5.135,1.913,3.4,1.34,5.078,2.059l2.519,1.081c.831.383,1.67.745,2.493,1.148-.878-.26-1.742-.561-2.613-.839l-2.587-.906c-1.725-.605-3.43-1.259-5.134-1.914s-3.4-1.341-5.078-2.061S325.9,359.337,324.249,358.545Z",
    transform: "translate(-320.519 -332.986)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.63,338.484c1.68-.436,3.373-.8,5.067-1.153s3.4-.668,5.1-.976c1.706-.292,3.411-.583,5.125-.822l2.573-.356c.862-.1,1.719-.213,2.584-.287-.839.225-1.685.408-2.527.612l-2.54.543c-1.693.36-3.4.668-5.1.975-1.7.291-3.411.582-5.125.821S333.358,338.322,331.63,338.484Z",
    transform: "translate(-322.92 -325.291)",
    fill: "#0c4767"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.963 70.47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.622,345.821a18.132,18.132,0,0,1,1.335-3.963,16.065,16.065,0,0,1,2.23-3.563,8.651,8.651,0,0,1,3.39-2.533,5.976,5.976,0,0,1,4.258.042,5.676,5.676,0,0,1,3.039,3.015,6.813,6.813,0,0,1,.571,2.1,4.686,4.686,0,0,1-.25,2.2,2.03,2.03,0,0,1-.746.955,1.464,1.464,0,0,1-.61.228,1.387,1.387,0,0,1-.672-.063,1.894,1.894,0,0,1-.872-.882,5.1,5.1,0,0,1-.4-1.04,13.74,13.74,0,0,1-.351-4.257,17.5,17.5,0,0,1,2.462-8.07,10.567,10.567,0,0,1,2.925-3.11,8.9,8.9,0,0,1,3.975-1.534,11.266,11.266,0,0,1,2.121-.187,14.886,14.886,0,0,1,2.116.209,12.951,12.951,0,0,1,3.95,1.5,16.494,16.494,0,0,1,3.307,2.593,17.524,17.524,0,0,1,2.6,3.274,18.206,18.206,0,0,0-6.073-5.578,12.665,12.665,0,0,0-3.863-1.364,14.624,14.624,0,0,0-2.039-.157,10.845,10.845,0,0,0-2.031.225,8.779,8.779,0,0,0-3.732,1.5,9.982,9.982,0,0,0-2.739,2.958,16.91,16.91,0,0,0-2.309,7.785,13.13,13.13,0,0,0,.3,4.045c.163.617.455,1.314.88,1.509.055,0,.091.034.156.036a1.227,1.227,0,0,0,.2-.006.85.85,0,0,0,.36-.132,1.431,1.431,0,0,0,.515-.669,4.1,4.1,0,0,0,.22-1.909,6.2,6.2,0,0,0-.507-1.921,5.277,5.277,0,0,0-2.707-2.776,5.507,5.507,0,0,0-3.915-.119,8.333,8.333,0,0,0-3.288,2.351A18.173,18.173,0,0,0,271.622,345.821Z",
    transform: "translate(-147.797 -160.165)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.217,379.011a9.558,9.558,0,0,1,2.727-3.128,10.148,10.148,0,0,1,3.778-1.81,8.1,8.1,0,0,1,4.219.083,8.409,8.409,0,0,1,3.6,2.243,10.637,10.637,0,0,1,2.255,3.6,9.846,9.846,0,0,1,.7,4.2,3.481,3.481,0,0,1-.783,2.106,1.636,1.636,0,0,1-1.136.512,2.438,2.438,0,0,1-1.163-.263,1.915,1.915,0,0,1-.837-.89,2.977,2.977,0,0,1-.253-1.133,6.216,6.216,0,0,1,.358-2.156,12.5,12.5,0,0,1,2.065-3.716,15,15,0,0,1,3.054-2.936,11.392,11.392,0,0,1,8.038-2.21,10.695,10.695,0,0,1,7.207,4.058,14.771,14.771,0,0,1,2.081,3.63,16.8,16.8,0,0,1,1.1,4.013,16.823,16.823,0,0,0-3.45-7.425,10.564,10.564,0,0,0-3.134-2.579,10.373,10.373,0,0,0-3.867-1.159,10.956,10.956,0,0,0-7.614,2.177,13.84,13.84,0,0,0-4.853,6.358,5.6,5.6,0,0,0-.34,1.922,1.633,1.633,0,0,0,.741,1.489,1.836,1.836,0,0,0,.844.2,1,1,0,0,0,.711-.318,2.925,2.925,0,0,0,.622-1.728,9.277,9.277,0,0,0-.638-3.941,10.465,10.465,0,0,0-2.105-3.427,8,8,0,0,0-3.346-2.169,7.676,7.676,0,0,0-4-.178A10.37,10.37,0,0,0,179.217,379.011Z",
    transform: "translate(-117.736 -175.87)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.359,127.8a18.187,18.187,0,0,0-1.957-8.008,8.347,8.347,0,0,0-2.632-3.068,5.509,5.509,0,0,0-3.83-.818,5.277,5.277,0,0,0-3.291,2.05,6.21,6.21,0,0,0-.951,1.743,4.113,4.113,0,0,0-.242,1.907,1.428,1.428,0,0,0,.34.773.848.848,0,0,0,.318.215,1.244,1.244,0,0,0,.192.054c.064.014.107-.006.161,0,.46-.088.91-.694,1.215-1.256a13.11,13.11,0,0,0,1.255-3.857,16.9,16.9,0,0,0-.385-8.11A9.969,9.969,0,0,0,106.6,105.9a8.775,8.775,0,0,0-3.266-2.349,10.764,10.764,0,0,0-1.919-.7,14.668,14.668,0,0,0-2.017-.335,12.679,12.679,0,0,0-4.078.4,18.2,18.2,0,0,0-7.228,3.967,17.494,17.494,0,0,1,3.309-2.557,16.45,16.45,0,0,1,3.83-1.729,12.946,12.946,0,0,1,4.193-.509,6.816,6.816,0,0,1,1.057.113,6.7,6.7,0,0,1,1.048.189,11.225,11.225,0,0,1,2.015.688,8.9,8.9,0,0,1,3.494,2.438,10.561,10.561,0,0,1,2.1,3.719,17.494,17.494,0,0,1,.465,8.424,13.749,13.749,0,0,1-1.357,4.05,5.09,5.09,0,0,1-.635.915,1.887,1.887,0,0,1-1.057.648,1.377,1.377,0,0,1-.668-.1,1.466,1.466,0,0,1-.538-.368,2.024,2.024,0,0,1-.5-1.105,4.68,4.68,0,0,1,.283-2.2,6.793,6.793,0,0,1,1.055-1.9,5.676,5.676,0,0,1,3.671-2.2,5.976,5.976,0,0,1,4.145.976,8.645,8.645,0,0,1,2.688,3.269,16.072,16.072,0,0,1,1.315,3.991A18.149,18.149,0,0,1,118.359,127.8Z",
    transform: "translate(-88.092 -87.593)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.348,192.059a18.187,18.187,0,0,0-8.243.035,8.344,8.344,0,0,0-3.6,1.843,5.5,5.5,0,0,0-1.689,3.533,5.273,5.273,0,0,0,1.225,3.678,6.208,6.208,0,0,0,1.473,1.332,4.11,4.11,0,0,0,1.8.68,1.429,1.429,0,0,0,.831-.15.834.834,0,0,0,.283-.26,1.182,1.182,0,0,0,.1-.174,1.5,1.5,0,0,0,.039-.156c.022-.468-.463-1.047-.937-1.475a13.125,13.125,0,0,0-3.458-2.12,16.9,16.9,0,0,0-7.975-1.519,9.978,9.978,0,0,0-3.886,1.077,8.784,8.784,0,0,0-3.046,2.628,10.773,10.773,0,0,0-1.132,1.7,6.32,6.32,0,0,0-.431.927,6.418,6.418,0,0,0-.365.956,12.665,12.665,0,0,0-.56,4.059,18.21,18.21,0,0,0,2.171,7.955,17.532,17.532,0,0,1-1.715-3.814,16.471,16.471,0,0,1-.787-4.128,12.932,12.932,0,0,1,.483-4.2,14.98,14.98,0,0,1,.785-1.976,11.269,11.269,0,0,1,1.139-1.8,8.9,8.9,0,0,1,3.185-2.828,10.576,10.576,0,0,1,4.106-1.173,17.5,17.5,0,0,1,8.3,1.514,13.758,13.758,0,0,1,3.622,2.264,5.113,5.113,0,0,1,.741.831,1.893,1.893,0,0,1,.385,1.179,1.391,1.391,0,0,1-.252.627,1.461,1.461,0,0,1-.482.437,2.03,2.03,0,0,1-1.191.224,4.678,4.678,0,0,1-2.073-.789,6.783,6.783,0,0,1-1.6-1.471,5.677,5.677,0,0,1-1.285-4.083,5.976,5.976,0,0,1,1.916-3.8,8.646,8.646,0,0,1,3.806-1.851,16.064,16.064,0,0,1,4.188-.347A18.149,18.149,0,0,1,339.348,192.059Z",
    transform: "translate(-160.098 -116.658)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.659,113.384a11.494,11.494,0,0,1-.264-4.959,12.173,12.173,0,0,1,1.731-4.7,9.667,9.667,0,0,1,3.674-3.44,10.042,10.042,0,0,1,4.939-1.082,12.728,12.728,0,0,1,4.92,1.19,11.734,11.734,0,0,1,4.094,3,4.115,4.115,0,0,1,1.077,2.422,1.9,1.9,0,0,1-.528,1.347,2.864,2.864,0,0,1-1.189.731,2.228,2.228,0,0,1-1.423-.061,3.5,3.5,0,0,1-1.144-.746,7.4,7.4,0,0,1-1.484-2.129,14.949,14.949,0,0,1-1.337-4.891,17.924,17.924,0,0,1,.155-5.054,13.609,13.609,0,0,1,5.007-8.592,12.961,12.961,0,0,1,4.519-2.244,13.094,13.094,0,0,1,5.016-.323,17.714,17.714,0,0,1,4.818,1.351,20.255,20.255,0,0,1,4.311,2.5,20.116,20.116,0,0,0-9.167-3.506,12.7,12.7,0,0,0-4.86.406,12.671,12.671,0,0,0-7.441,5.929,14.29,14.29,0,0,0-1.59,4.587,16.6,16.6,0,0,0,1.167,9.548A6.77,6.77,0,0,0,308,106.621a2.017,2.017,0,0,0,1.943.669,2.244,2.244,0,0,0,.914-.556,1.261,1.261,0,0,0,.359-.911,3.554,3.554,0,0,0-.928-2.039,11.151,11.151,0,0,0-3.869-2.856,12.537,12.537,0,0,0-4.694-1.175,9.63,9.63,0,0,0-4.705.955,9.24,9.24,0,0,0-3.584,3.218A12.407,12.407,0,0,0,291.659,113.384Z",
    transform: "translate(-154.18 -81.635)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.864 198.672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.542,380.325a2.869,2.869,0,1,0,1.872,3.6A2.868,2.868,0,0,0,172.542,380.325Zm1.54,3.493a2.519,2.519,0,1,1-1.643-3.159A2.518,2.518,0,0,1,174.081,383.818Zm-1.54-3.493a2.869,2.869,0,1,0,1.872,3.6A2.868,2.868,0,0,0,172.542,380.325Zm1.54,3.493a2.519,2.519,0,1,1-1.643-3.159A2.518,2.518,0,0,1,174.081,383.818Zm-1.54-3.493a2.869,2.869,0,1,0,1.872,3.6A2.868,2.868,0,0,0,172.542,380.325Zm1.54,3.493a2.519,2.519,0,1,1-1.643-3.159A2.518,2.518,0,0,1,174.081,383.818Zm-.584-6.524a6.047,6.047,0,1,0,3.948,7.584A6.05,6.05,0,0,0,173.5,377.294Zm1.343,6.763a3.314,3.314,0,1,1-2.164-4.157A3.318,3.318,0,0,1,174.84,384.057Zm-.426-.134a2.868,2.868,0,1,0-3.6,1.874A2.868,2.868,0,0,0,174.414,383.923Zm-.333-.105a2.519,2.519,0,1,1-1.643-3.159A2.518,2.518,0,0,1,174.081,383.818Zm-1.54-3.493a2.869,2.869,0,1,0,1.872,3.6A2.868,2.868,0,0,0,172.542,380.325Zm1.54,3.493a2.519,2.519,0,1,1-1.643-3.159A2.518,2.518,0,0,1,174.081,383.818Zm-1.54-3.493a2.869,2.869,0,1,0,1.872,3.6A2.868,2.868,0,0,0,172.542,380.325Zm1.54,3.493a2.519,2.519,0,1,1-1.643-3.159A2.518,2.518,0,0,1,174.081,383.818Z",
    transform: "translate(-164.18 -375.708)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.408,394.351l-2.218-.7-.372,1.608,1.972.621Z",
    transform: "translate(-165.543 -381.122)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.557,390.616l-1.074-2.062-1.4.874.955,1.834Z",
    transform: "translate(-163.677 -379.463)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.012,384.007l.7-2.218-1.608-.372-.622,1.972Z",
    transform: "translate(-163.481 -377.141)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.517,378.156l2.062-1.074-.874-1.4-1.834.955Z",
    transform: "translate(-164.909 -375.275)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.182,376.611l2.218.7.372-1.608-1.972-.622Z",
    transform: "translate(-167.287 -375.08)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.09,380.116l1.074,2.062,1.4-.874-.955-1.834Z",
    transform: "translate(-169.209 -376.508)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.753,386.781l-.7,2.218,1.608.372.621-1.972Z",
    transform: "translate(-169.523 -378.886)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.017,392.688l-2.062,1.074.874,1.4,1.834-.955Z",
    transform: "translate(-167.864 -380.808)",
    fill: "#0c4767"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(152.115 167.118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.639,346.237a9.242,9.242,0,1,0-12.93,1.915A9.242,9.242,0,0,0,333.639,346.237Zm-3.956-2.936a4.316,4.316,0,1,1-.894-6.036A4.316,4.316,0,0,1,329.683,343.3Z",
    transform: "translate(-314.665 -329.344)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.94,356.278l-2.854-2.118-1.341,2.137,2.538,1.884Z",
    transform: "translate(-315.242 -336.72)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.533,348.2l-.52-3.516-2.46.563.463,3.127Z",
    transform: "translate(-313.552 -333.638)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.34,337.7l2.118-2.854L317.32,333.5l-1.884,2.538Z",
    transform: "translate(-314.165 -330)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.574,331.291l3.516-.52-.563-2.46-3.127.463Z",
    transform: "translate(-317.407 -328.311)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.836,332.1l2.854,2.118,1.341-2.137-2.538-1.884Z",
    transform: "translate(-320.802 -328.923)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.829,340.332l.52,3.516,2.46-.563-.463-3.127Z",
    transform: "translate(-323.077 -332.165)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.52,350.594l-2.118,2.854,2.137,1.341,1.884-2.538Z",
    transform: "translate(-321.962 -335.56)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.446,357.587l-3.516.52.563,2.46,3.127-.463Z",
    transform: "translate(-318.88 -337.835)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.767,344.2l1.963,2.476,3.127-.464,1.16-2.937-1.961-2.475-3.126.461Zm3.722-1.267a1,1,0,1,1-1.4.208A1,1,0,0,1,329.489,342.937Z",
    transform: "translate(-317.526 -332.375)",
    fill: "#0c4767"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(170.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.027,85.2a2.51,2.51,0,1,0,1.639,3.149A2.51,2.51,0,0,0,349.027,85.2Zm1.347,3.056a2.2,2.2,0,1,1-1.438-2.764A2.2,2.2,0,0,1,350.374,88.26ZM349.027,85.2a2.51,2.51,0,1,0,1.639,3.149A2.51,2.51,0,0,0,349.027,85.2Zm1.347,3.056a2.2,2.2,0,1,1-1.438-2.764A2.2,2.2,0,0,1,350.374,88.26ZM349.027,85.2a2.51,2.51,0,1,0,1.639,3.149A2.51,2.51,0,0,0,349.027,85.2Zm1.347,3.056a2.2,2.2,0,1,1-1.438-2.764A2.2,2.2,0,0,1,350.374,88.26Zm-.511-5.709a5.292,5.292,0,1,0,3.454,6.637A5.294,5.294,0,0,0,349.864,82.551Zm1.175,5.918a2.9,2.9,0,1,1-1.894-3.637A2.9,2.9,0,0,1,351.039,88.469Zm-.373-.117a2.51,2.51,0,1,0-3.147,1.64A2.511,2.511,0,0,0,350.666,88.352Zm-.291-.092a2.2,2.2,0,1,1-1.438-2.764A2.2,2.2,0,0,1,350.374,88.26ZM349.027,85.2a2.51,2.51,0,1,0,1.639,3.149A2.51,2.51,0,0,0,349.027,85.2Zm1.347,3.056a2.2,2.2,0,1,1-1.438-2.764A2.2,2.2,0,0,1,350.374,88.26ZM349.027,85.2a2.51,2.51,0,1,0,1.639,3.149A2.51,2.51,0,0,0,349.027,85.2Zm1.347,3.056a2.2,2.2,0,1,1-1.438-2.764A2.2,2.2,0,0,1,350.374,88.26Z",
    transform: "translate(-341.71 -81.164)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.911,97.477l-1.94-.611-.326,1.407,1.726.544Z",
    transform: "translate(-342.903 -85.9)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.79,94.208l-.94-1.8-1.225.765.836,1.6Z",
    transform: "translate(-341.27 -84.449)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.438,88.426l.611-1.94-1.407-.325-.544,1.726Z",
    transform: "translate(-341.099 -82.418)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.506,83.305l1.8-.94-.765-1.225-1.6.836Z",
    transform: "translate(-342.348 -80.785)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.338,81.953l1.94.611.326-1.407-1.726-.544Z",
    transform: "translate(-344.43 -80.613)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.507,85.02l.94,1.8,1.225-.765-.836-1.6Z",
    transform: "translate(-346.111 -81.863)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.962,90.853l-.611,1.94,1.407.325.544-1.726Z",
    transform: "translate(-346.386 -83.944)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.693,96.022l-1.8.94.765,1.225,1.6-.836Z",
    transform: "translate(-344.934 -85.626)",
    fill: "#0c4767"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144.916 96.389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.812,228.069a2.51,2.51,0,1,0,1.638,3.149A2.511,2.511,0,0,0,310.812,228.069Zm1.347,3.056a2.2,2.2,0,1,1-1.438-2.764A2.2,2.2,0,0,1,312.158,231.125Zm-1.347-3.056a2.51,2.51,0,1,0,1.638,3.149A2.511,2.511,0,0,0,310.812,228.069Zm1.347,3.056a2.2,2.2,0,1,1-1.438-2.764A2.2,2.2,0,0,1,312.158,231.125Zm-1.347-3.056a2.51,2.51,0,1,0,1.638,3.149A2.511,2.511,0,0,0,310.812,228.069Zm1.347,3.056a2.2,2.2,0,1,1-1.438-2.764A2.2,2.2,0,0,1,312.158,231.125Zm-.51-5.709a5.291,5.291,0,1,0,3.454,6.636A5.294,5.294,0,0,0,311.648,225.416Zm1.175,5.918a2.9,2.9,0,1,1-1.894-3.637A2.9,2.9,0,0,1,312.823,231.334Zm-.373-.117a2.51,2.51,0,1,0-3.147,1.64A2.51,2.51,0,0,0,312.45,231.217Zm-.291-.092a2.2,2.2,0,1,1-1.438-2.764A2.2,2.2,0,0,1,312.158,231.125Zm-1.347-3.056a2.51,2.51,0,1,0,1.638,3.149A2.511,2.511,0,0,0,310.812,228.069Zm1.347,3.056a2.2,2.2,0,1,1-1.438-2.764A2.2,2.2,0,0,1,312.158,231.125Zm-1.347-3.056a2.51,2.51,0,1,0,1.638,3.149A2.511,2.511,0,0,0,310.812,228.069Zm1.347,3.056a2.2,2.2,0,1,1-1.438-2.764A2.2,2.2,0,0,1,312.158,231.125Z",
    transform: "translate(-303.495 -224.029)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.695,240.342l-1.94-.611-.326,1.407,1.726.544Z",
    transform: "translate(-304.687 -228.766)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.575,237.073l-.94-1.8-1.225.765.836,1.6Z",
    transform: "translate(-303.054 -227.314)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.222,231.291l.611-1.94-1.407-.326-.544,1.726Z",
    transform: "translate(-302.883 -225.283)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.29,226.17l1.8-.94-.765-1.225-1.6.836Z",
    transform: "translate(-304.132 -223.65)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.122,224.818l1.94.611.325-1.407-1.726-.544Z",
    transform: "translate(-306.214 -223.479)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.291,227.886l.94,1.8,1.225-.765-.836-1.6Z",
    transform: "translate(-307.895 -224.728)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.746,233.718l-.611,1.94,1.407.326.544-1.726Z",
    transform: "translate(-308.17 -226.81)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.477,238.887l-1.8.94.765,1.225,1.6-.836Z",
    transform: "translate(-306.718 -228.491)",
    fill: "#0c4767"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg404);
export default __webpack_public_path__ + "static/media/img_404.df4ea3065289f02a50635ddcd99263b0.svg";
export { ForwardRef as ReactComponent };